/**
 * 블로그 목록 항목 → 카드 항목
 * @description 서버 모양(`BlogItem`)을 화면이 알 필요는 없으므로 여기서 한 겹 접는다.
 */
import type { SpotlightItem } from "./DiscoverySpotlights.types";

import type { BlogItem } from "@/domains/core/post";

/**
 * 카드 제목으로 쓸 한 줄짜리 문장을 만든다.
 *
 * 제목이 없는 글은 **본문이 제목 자리에 선다.** 그런데 본문은 사람이 쓴 글이라 줄바꿈이
 * 그대로 들어 있다 — 문단 사이 빈 줄까지. 카드는 두 줄에서 끊으므로 그 빈 줄이 두 줄 중
 * 하나를 통째로 먹는다. 그래서 이어지는 공백을 한 칸으로 접는다.
 * @example toCardTitle("Apobangpo\n\n오늘 다녀왔어요") // "Apobangpo 오늘 다녀왔어요"
 */
export const toCardTitle = (text?: string): string =>
  text?.replace(/\s+/g, " ").trim() ?? "";

export function toSpotlightItem(item: BlogItem): SpotlightItem {
  return {
    itemType: item.itemType,
    slug: item.slug,
    /* 제목은 서버가 채워 보내지만 런타임까지 보장되지는 않아, 비면 요약으로 받친다 */
    title: toCardTitle(item.title) || toCardTitle(item.excerpt),
    thumbnailUrl: item.coverImageUrl ?? undefined,
    displayName: item.author.name,
  };
}
